import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import { connect } from 'react-redux';

import { loadDesign } from "../actions/index";

const LoadDesign = ({ designs, onSelectDesign, iconOnly }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    function handleClick(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose(designId) {
        setAnchorEl(null);
        if (designId) {
            onSelectDesign(designId);
        }
    }

    return (
        <React.Fragment>
            {iconOnly ? (
                <Tooltip title="Load Example">
                    <IconButton aria-controls="load-design" aria-haspopup="true" aria-label="Load Example" onClick={handleClick}>
                        <FolderOpenIcon />
                    </IconButton>
                </Tooltip>
            ) : (
                <Button color="inherit" aria-controls="load-design" aria-haspopup="true" onClick={handleClick}>
                    Load Example
                </Button>
            )}
            <Menu
                id="load-design"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => handleClose()}
            >
                {
                    Object.keys(designs).map((key) => {
                        return (
                            <MenuItem key={key} onClick={() => handleClose(key)} value={key}>{key}</MenuItem>
                        );
                    })
                }
            </Menu>
        </React.Fragment>
    );
}

const mapStateToProps = (state) => {
    return {
        row: state.row,
        designs: state.design.designs
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSelectDesign: (designId) => {
            dispatch(loadDesign({
                designId
            }));
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoadDesign);